import { useProjectContext } from './ProjectContext.tsx';
import { PermissionRequirement } from './types/projectPermission.ts';
import { FeatureFlags } from 'application/constants/env-variables.ts';

export function useHasProjectPermission() {
  const { project } = useProjectContext();

  return (
    requirements: PermissionRequirement[],

    // TODO: Remove this argument once the feature flag is removed from the codebase.
    ignoreFeatureFlag?: ReturnType<
      (typeof FeatureFlags)['projectPermissionsEnabled']
    >,
  ) => {
    if (!ignoreFeatureFlag && !FeatureFlags.projectPermissionsEnabled())
      return true;
    if (!project) return false;
    if (!project.isPrivate) return true;

    return requirements.every(({ resource, operations }) => {
      const permissions = project?.currentUserPermissions?.[resource] ?? [];

      return operations.every((operation) => permissions.includes(operation));
    });
  };
}
